import React from 'react'
import { RichTextDisplay } from '@ztechapps/webui.input'

export const TextTemplateDisplayValue = ({ value }) => {
  return <RichTextDisplay as="pre" style={{ whiteSpace: 'pre-line' }} contentHtml={value} />
}
